import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Router } from '@angular/router';

// Importaciones de servicios.
import { AuthService } from '../services/auth.service';

/**
 * Guard de ruta que verifica si el usuario está autenticado.
 *
 * Este guard se utiliza para proteger las rutas que requieren autenticación.
 * Comprueba si el usuario está autenticado mediante el servicio de autenticación.
 * Si el usuario no está autenticado, se cierra la sesión y se redirige
 * al usuario a la página de inicio de sesión.
 *
 * @returns Devuelve false si el usuario no está autenticado y se
 * redirige a la página de inicio de sesión. Devuelve true si el usuario
 * está autenticado y puede acceder a la ruta protegida.
 */
export const authGuard: CanActivateFn = (): boolean => {
  const authService = inject(AuthService);
  
  if (!authService.isValidToken(authService.getToken())) {
    const router = inject(Router);

    authService.removeToken();
    router.navigateByUrl('/login');
    
    return false;
  }

  return true;
};
